import { i18n } from "src/boot/i18n"
import { LINKS } from "src/env/links"
import { MainMenuType } from "src/util/enums/entityType"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { GlobalNamedPath, NamedManagerPath, NamedPath } from "src/util/enums/namedPaths"
import { AttachmentContext } from "src/util/types/dataModels/attachment"
import { EntityPages, MenuData, MenuDataManager } from "src/util/types/dataModels/entityDefinition"

export function getExtendedMenuData(item: MainMenuType, workspaceId: string): MenuData {
  const { t } = i18n.global

  switch (item) {
    case MainMenuType.WORKSPACES:
      return {
        icon: Icons.WORKSPACES,
        label: t("sfxNavigation.workspaces"),
        to: { name: NamedPath.SELECT_WORKSPACE },
        disable: false,
      }
    case MainMenuType.SETTINGS:
      return {
        icon: Icons.SETTINGS,
        label: t("sfxNavigation.settings"),
        to: { name: NamedPath.USER_SETTINGS },
        disable: false,
      }
    case MainMenuType.ATTACHMENTS:
      return {
        icon: Icons.ATTACHMENTS,
        label: t("sfxNavigation.attachments"),
        to: "ADD ME",
        disable: true,
      }
    case MainMenuType.ZONES:
      return {
        icon: Icons.ZONES,
        label: t("sfxNavigation.zones"),
        to: { name: NamedPath.SELECT_ZONE, params: { workspaceId } },
        disable: true,
      }
    case MainMenuType.LAYOUTS:
      return {
        icon: Icons.LAYOUTS,
        label: t("sfxNavigation.layouts"),
        to: { name: NamedPath.SELECT_LAYOUT, params: { workspaceId } },
        disable: true,
      }
    case MainMenuType.AREAS:
      return {
        icon: Icons.AREAS,
        label: t("sfxNavigation.areas"),
        to: { name: NamedPath.SELECT_AREA, params: { workspaceId } },
        disable: true,
      }
    case MainMenuType.LOCATIONS:
      return {
        icon: Icons.LOCATIONS,
        label: t("sfxNavigation.locations"),
        to: "ADD ME",
        disable: true,
      }
    case MainMenuType.MODELS:
      return {
        icon: Icons.MODELS,
        label: t("sfxNavigation.models"),
        to: { name: NamedPath.SELECT_MODEL, params: { workspaceId } },
        disable: true,
      }
    case MainMenuType.ITEMS:
      return {
        icon: Icons.ITEMS,
        label: t("sfxNavigation.items"),
        to: { name: NamedPath.SELECT_ITEM, params: { workspaceId } },
        disable: false,
      }
    case MainMenuType.PERFORMED_WORK:
      return {
        icon: Icons.PERFORMED_WORK_LIST,
        label: t("sfxNavigation.performed_work"),
        to: { name: NamedPath.SELECT_PERFORMED_WORK, params: { workspaceId } },
        disable: false,
      }
    case MainMenuType.ISSUES:
      return {
        icon: Icons.ISSUES,
        label: t("sfxNavigation.issues"),
        to: { name: NamedPath.SELECT_ISSUE, params: { workspaceId } },
        disable: false,
      }
    default:
      return {
        icon: Icons.WARNING,
        label: t("sfxNavigation.error"),
        to: { name: GlobalNamedPath.NOT_FOUND },
      }
  }
}

export function getExtendedMenuDataManager(
  item: MainMenuType,
  workspaceId: string
): MenuDataManager {
  const { t } = i18n.global

  // TODO: to { name:should be fixe }d for all
  switch (item) {
    case MainMenuType.WORKSPACES:
      return {
        icon: Icons.WORKSPACES,
        name: "workspaces",
        label: t("sfxNavigation.workspaces"),
        to: { name: NamedManagerPath.SELECT_WORKSPACE },
        disable: false,
      }
    case MainMenuType.ATTACHMENTS:
      return {
        icon: Icons.ATTACHMENTS,
        name: "attachments",
        label: t("sfxNavigation.attachments"),
        to: "ADD ME",
        disable: true,
      }
    case MainMenuType.ZONES:
      return {
        icon: Icons.ZONES,
        name: "zones",
        label: t("sfxNavigation.zones"),
        to: "ADD ME",
        disable: true,
      }
    case MainMenuType.LAYOUTS:
      return {
        icon: Icons.LAYOUTS,
        name: "layouts",
        label: t("sfxNavigation.layouts"),
        to: "ADD ME",
        disable: true,
      }
    case MainMenuType.AREAS:
      return {
        icon: Icons.AREAS,
        name: "areas",
        label: t("sfxNavigation.areas"),
        to: "ADD ME",
        disable: true,
      }
    case MainMenuType.LOCATIONS:
      return {
        icon: Icons.LOCATIONS,
        name: "locations",
        label: t("sfxNavigation.locations"),
        to: "ADD ME",
        disable: true,
      }
    case MainMenuType.MODELS:
      return {
        icon: Icons.MODELS,
        name: "models",
        label: t("sfxNavigation.models"),
        to: "ADD ME",
        disable: true,
      }
    case MainMenuType.ITEMS:
      return {
        icon: Icons.ITEMS,
        name: "items",
        label: t("sfxNavigation.items"),
        to: { name: NamedManagerPath.SELECT_ITEM, params: { workspaceId } },
        disable: false,
      }
    case MainMenuType.PERFORMED_WORK:
      return {
        icon: Icons.PERFORMED_WORK_LIST,
        name: "performed-work",
        label: t("sfxNavigation.performed_work"),
        to: { name: NamedManagerPath.SELECT_PERFORMED_WORK, params: { workspaceId } },
        disable: false,
      }
    case MainMenuType.ISSUES:
      return {
        icon: Icons.ISSUES,
        name: "issues",
        label: t("sfxNavigation.issues"),
        to: { name: NamedManagerPath.SELECT_ISSUE, params: { workspaceId } },
        disable: false,
      }
    case MainMenuType.HOME:
      return {
        icon: Icons.HOME,
        name: "home",
        label: t("sfxNavigation.home"),
        to: { name: NamedManagerPath.WORKSPACE, params: { workspaceId } },
        disable: false,
      }
    case MainMenuType.ANALYTICS:
      return {
        icon: Icons.ANALYTICS,
        name: "analytics",
        label: t("sfxNavigation.analytics"),
        to: "ADD ME",
        disable: true,
      }
    case MainMenuType.WORK_ORDERS:
      return {
        icon: Icons.WORK_ORDERS,
        name: "work-orders",
        label: t("sfxNavigation.work_orders"),
        to: { name: NamedManagerPath.SELECT_WORK_ORDER, params: { workspaceId } },
        disable: false,
      }
    case MainMenuType.ADMINISTRATION:
      return {
        icon: Icons.ADMINISTRATION,
        name: "administration",
        label: t("sfxNavigation.administrate"),
        externalLink: LINKS.USER_MANAGEMENT_URL,
        disable: false,
      }
    case MainMenuType.AUDIT:
      return {
        icon: Icons.AUDIT_ACCEPTED,
        name: "audit",
        label: t("sfxNavigation.audit"),
        to: "ADD ME",
        disable: true,
      }
    case MainMenuType.IDENTIFY:
      return {
        icon: Icons.IDENTIFY,
        name: "identify",
        label: t("sfxNavigation.identify"),
        to: "ADD ME",
        disable: true,
      }
    case MainMenuType.CHANGE_REQUESTS:
      return {
        icon: Icons.CHANGE_REQUESTS,
        name: "change-requests",
        label: t("sfxNavigation.change_requests"),
        to: "ADD ME",
        disable: true,
      }
    case MainMenuType.WORK_DOMAINS:
      return {
        icon: Icons.WORKDOMAINS,
        name: "work-domains",
        label: t("sfxNavigation.work_domains"),
        to: "ADD ME",
        disable: true,
      }
    default:
      return {
        icon: Icons.WARNING,
        name: "error",
        label: t("sfxNavigation.error"),
        to: { name: GlobalNamedPath.NOT_FOUND },
      }
  }
}

export function getTranslatedEntityForPage(entity: EntityPages, isPlural = false) {
  const { t } = i18n.global

  const count = isPlural ? 2 : 1

  switch (entity) {
    case "item": {
      return t("sfxTable.entity_item", count)
    }
    case "issue": {
      return t("sfxTable.entity_issue", count)
    }
    case "model": {
      return t("sfxTable.entity_model", count)
    }
    case "performed_work": {
      return t("sfxTable.entity_performed_work", count)
    }
    case "area": {
      return t("sfxTable.entity_area", count)
    }
    case "layout": {
      return t("sfxTable.entity_layout", count)
    }
    case "workspace": {
      return t("sfxTable.entity_workspace", count)
    }
    case "zone": {
      return t("sfxTable.entity_zone", count)
    }
    case "work_order": {
      return t("sfxTable.entity_work_order", count)
    }
    case "attachment": {
      return t("sfxTable.entity_attachment", count)
    }
    case "location": {
      return t("sfxTable.entity_location", count)
    }
  }
}

export function getTranslatedEntityForAttachment(entity: AttachmentContext): string {
  const { t } = i18n.global

  switch (entity) {
    case "item":
      return t("attachmentContext.item")

    case "item_model":
      return t("attachmentContext.item_model")

    case "corrective_work_area":
    case "corrective_work_item":
    case "corrective_work_item_comment":
      return t("attachmentContext.corrective_work")

    case "regular_work_area":
    case "regular_work_item":
    case "regular_work_item_comment":
      return t("attachmentContext.regular_work")

    case "issue_area":
    case "issue_item":
    case "issue_item_comment":
      return t("attachmentContext.issue")

    case "work_order_corrective_item":
    case "work_order_corrective_area":
    case "work_order_corrective_item_comment":
    case "work_order_corrective_area_comment":
      return t("attachmentContext.corrective_work_order")

    case "work_order_regular_item":
    case "work_order_regular_area":
    case "work_order_regular_item_comment":
    case "work_order_regular_area_comment":
      return t("attachmentContext.regular_work_order")

    case "area":
      return t("attachmentContext.area")

    case "zone":
      return t("attachmentContext.zone")
  }
}
